'use client';
import React from 'react';
import Typography from '@mui/material/Typography';

interface InfoBannerProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  className?: string; // Add className prop for custom styling
}

const Heading: React.FC<InfoBannerProps> = ({ title, subtitle, className }) => {
  return (
    <div className={`text-center ${className || ''}`}>
      <Typography component="h2" variant="h1" color="textPrimary" className="mb-2">
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="s1"
          color="textSecondary"
          component="p"
          className="leading-6 md:leading-7"
        >
          {subtitle}
        </Typography>
      )}
    </div>
  );
};

export default Heading;
